import React, { useCallback, useEffect, useState } from 'react'
import {Box, Tabs, Tab, TextField, MenuItem, Select} from '@mui/material'

import DialogHeader from '@/view/layout/DialogHeader'
import HeaderSpacer from '@/view/layout/HeaderSpacer'
import StatService, {AttendStatDto, AttackStatDto, PointStatDto} from '@/service/StatService'

interface Props {
    onClose: () => void
}

const RankView = ({ onClose }: Props) => {

    const handleOverlayClick = useCallback(() => onClose(), [onClose])

    const [tabIndex, setTabIndex] = useState(0)
    const [year, setYear] = useState(new Date().getFullYear())

    const [attendList, setAttendList] = useState<AttendStatDto[]>([])
    const [pointList, setPointList] = useState<PointStatDto[]>([])
    const [attackList, setAttackList] = useState<AttackStatDto[]>([])
    const [month, setMonth] = useState<string | ''>('')

    useEffect(() => {
        if(year)
            loadData()
    }, [year, month])

    const loadData = async () => {
        setAttendList(await StatService.getAttendStats(year, month))
        setPointList(await StatService.getPointStats(year, month))
        setAttackList(await StatService.getAttackStats(year, month))
       }

    return (
        <>
            <DialogHeader title="랭킹" onClose={handleOverlayClick} />

            <div className="rank-board">
                <HeaderSpacer />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'2px'}}>
                    {/* YEAR */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, minHeight: '40px', marginBottom: '0px' }}>
                        <Select
                            sx={{ height: '40px'}}
                            size="small"
                            value={year}
                            onChange={e => setYear(Number(e.target.value))}
                        >

                          <MenuItem key={'2026'} value={'2026'}>2026</MenuItem>

                        </Select>
                    </Box>

                    {/* MONTH */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, minHeight: '40px', marginBottom: '0px' }}>
                        <Select
                            sx={{ height: '40px', ml: 1 }}
                            size="small"
                            value={month}
                            onChange={e => setMonth(e.target.value === '' ? '' : String(e.target.value))}
                        >
                            <MenuItem key={''} value="">전체</MenuItem>
                            <MenuItem key={'01'} value={'01'}>01</MenuItem>
                            <MenuItem key={'02'} value={'02'}>02</MenuItem>
                            <MenuItem key={'03'} value={'03'}>03</MenuItem>
                            <MenuItem key={'04'} value={'04'}>04</MenuItem>
                            <MenuItem key={'05'} value={'05'}>05</MenuItem>
                            <MenuItem key={'06'} value={'06'}>06</MenuItem>
                            <MenuItem key={'07'} value={'07'}>07</MenuItem>
                            <MenuItem key={'08'} value={'08'}>08</MenuItem>
                            <MenuItem key={'09'} value={'09'}>09</MenuItem>
                            <MenuItem key={'10'} value={'10'}>10</MenuItem>
                            <MenuItem key={'11'} value={'11'}>11</MenuItem>
                            <MenuItem key={'12'} value={'12'}>12</MenuItem>
                        </Select>
                    </Box>
                </div>

                {/* TABS */}
                <Tabs
                    value={tabIndex}
                    onChange={(_, v) => setTabIndex(v)}
                    variant="fullWidth"
                >
                    <Tab label="참석률" />
                    <Tab label="승점" />
                    <Tab label="공격포인트" />
                </Tabs>

                {/* CONTENT */}
                <Box className="rank-content">

                    {tabIndex === 0 && (
                        <>
                            {/* 출석률 헤더 */}
                            <Box className="rank-row rank-header">
                                <span>순위</span>
                                <span>이름</span>
                                <span>출석률</span>
                                <span>참석/전체</span>
                            </Box>

                            {attendList.map(r => {
                                const trophy =
                                    r.ranking === 1 ? "🥇" :
                                        r.ranking === 2 ? "🥈" :
                                            r.ranking === 3 ? "🥉" :
                                                r.ranking;

                                return (
                                    <Box key={`1-${r.ranking}-${r.name}`} className="rank-row">
                                        <span>{trophy}</span>
                                        <span>{r.name}</span>
                                        <span>{r.attendRatio}%</span>
                                        <span>{r.attendGameCnt}/{r.totalGameCnt}</span>
                                    </Box>
                                );
                            })}
                        </>
                    )}

                    {tabIndex === 1 && (
                        <>
                            {/* 포인트 헤더 */}
                            <Box className="rank-row rank-header">
                                <span>순위</span>
                                <span>이름</span>
                                <span>포인트</span>
                                <span>승/무/패</span>
                            </Box>

                            {pointList.map(r => {
                                const trophy =
                                    r.ranking === 1 ? "🥇" :
                                        r.ranking === 2 ? "🥈" :
                                            r.ranking === 3 ? "🥉" :
                                                r.ranking;

                                return (
                                    <Box key={`2-${r.ranking}-${r.name}`} className="rank-row">
                                        <span>{trophy}</span>
                                        <span>{r.name}</span>
                                        <span>{r.totalPoint}점</span>
                                        <span>{r.winCnt}/{r.drawCnt}/{r.loseCnt}</span>
                                    </Box>
                                );
                            })}
                        </>
                    )}

                    {tabIndex === 2 && (
                        <>
                            {/* 공격포인트 헤더 */}
                            <Box className="rank-row rank-header">
                                <span>순위</span>
                                <span>이름</span>
                                <span>공격포인트</span>
                            </Box>

                            {attackList.map(r => {
                                const trophy =
                                    r.ranking === 1 ? "🥇" :
                                        r.ranking === 2 ? "🥈" :
                                            r.ranking === 3 ? "🥉" :
                                                r.ranking;

                                return (
                                    <Box key={`3-${r.ranking}-${r.name}`} className="rank-row">
                                        <span>{trophy}</span>
                                        <span>{r.name}</span>
                                        <span>{r.goal}골 / {r.assist}도움</span>
                                    </Box>
                                );
                            })}
                        </>
                    )}

                </Box>
            </div>
        </>
    )
}

export default RankView
